/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDocumentRequestCommand,
  CreateDocumentRequestCommandResponse,
  DocumentRequestDetailQueryResponse,
  DocumentRequestQueryResponse,
  GetDocumentRequestFileParams,
  GetDocumentRequestsParams,
  UpdateDocumentRequestCommandBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocumentRequests = (
    params: GetDocumentRequestsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DocumentRequestQueryResponse>(
      {url: `/api/v1/document-request`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDocumentRequestsQueryKey = (params: GetDocumentRequestsParams,) => {
    return [`/api/v1/document-request`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequests>>, GetDocumentRequestsParams['page']>, TError = ErrorType<unknown>>(params: GetDocumentRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']> = ({ signal, pageParam }) => getDocumentRequests({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequests>>>
export type GetDocumentRequestsInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequests>>, GetDocumentRequestsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequests>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequests>>, GetDocumentRequestsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequests>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequests>>, GetDocumentRequestsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequests>>, GetDocumentRequestsParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequests>>, QueryKey, GetDocumentRequestsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(params: GetDocumentRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequests>>> = ({ signal }) => getDocumentRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequests>>>
export type GetDocumentRequestsQueryError = ErrorType<unknown>


export function useGetDocumentRequests<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequests>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequests<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequests>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequests<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequests<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(params: GetDocumentRequestsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequests>>> = ({ signal }) => getDocumentRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequests>>>
export type GetDocumentRequestsSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentRequestsSuspense<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestsSuspense<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestsSuspense<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestsSuspense<TData = Awaited<ReturnType<typeof getDocumentRequests>>, TError = ErrorType<unknown>>(
 params: GetDocumentRequestsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequests>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createDocumentRequest = (
    createDocumentRequestCommand: BodyType<CreateDocumentRequestCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(createDocumentRequestCommand.file !== undefined) {
 formData.append('file', createDocumentRequestCommand.file)
 }
formData.append('status', createDocumentRequestCommand.status)
if(createDocumentRequestCommand.justification !== undefined) {
 formData.append('justification', createDocumentRequestCommand.justification)
 }
if(createDocumentRequestCommand.companyDocumentPublicId !== undefined) {
 formData.append('companyDocumentPublicId', createDocumentRequestCommand.companyDocumentPublicId)
 }
formData.append('implantationDate', createDocumentRequestCommand.implantationDate)
formData.append('reason', createDocumentRequestCommand.reason)
formData.append('reasonFields', JSON.stringify(createDocumentRequestCommand.reasonFields));
if(createDocumentRequestCommand.responsibleCompanyId !== undefined) {
 formData.append('responsibleCompanyId', createDocumentRequestCommand.responsibleCompanyId.toString())
 }
if(createDocumentRequestCommand.responsibleUserId !== undefined) {
 formData.append('responsibleUserId', createDocumentRequestCommand.responsibleUserId)
 }
formData.append('observation', createDocumentRequestCommand.observation)

      return instance<CreateDocumentRequestCommandResponse>(
      {url: `/api/v1/document-request`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getCreateDocumentRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentRequest>>, TError,{data: BodyType<CreateDocumentRequestCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentRequest>>, TError,{data: BodyType<CreateDocumentRequestCommand>}, TContext> => {
    
const mutationKey = ['createDocumentRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentRequest>>, {data: BodyType<CreateDocumentRequestCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createDocumentRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentRequest>>>
    export type CreateDocumentRequestMutationBody = BodyType<CreateDocumentRequestCommand>
    export type CreateDocumentRequestMutationError = ErrorType<unknown>

    export const useCreateDocumentRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentRequest>>, TError,{data: BodyType<CreateDocumentRequestCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentRequest>>,
        TError,
        {data: BodyType<CreateDocumentRequestCommand>},
        TContext
      > => {

      const mutationOptions = getCreateDocumentRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getDocumentRequest = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DocumentRequestDetailQueryResponse>(
      {url: `/api/v1/document-request/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDocumentRequestQueryKey = (id: number,) => {
    return [`/api/v1/document-request/${id}`] as const;
    }

    
export const getGetDocumentRequestInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequest>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequest>>> = ({ signal }) => getDocumentRequest(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequest>>>
export type GetDocumentRequestInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequest>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequest>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequest>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequest>>> = ({ signal }) => getDocumentRequest(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequest>>>
export type GetDocumentRequestQueryError = ErrorType<unknown>


export function useGetDocumentRequest<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequest>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequest<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequest>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequest<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequest<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequest>>> = ({ signal }) => getDocumentRequest(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequest>>>
export type GetDocumentRequestSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentRequestSuspense<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestSuspense<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestSuspense<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestSuspense<TData = Awaited<ReturnType<typeof getDocumentRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequest>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateDocumentRequest = (
    id: number,
    updateDocumentRequestCommandBody: BodyType<UpdateDocumentRequestCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      const formData = new FormData();
if(updateDocumentRequestCommandBody.file !== undefined) {
 formData.append('file', updateDocumentRequestCommandBody.file)
 }
formData.append('status', updateDocumentRequestCommandBody.status)
if(updateDocumentRequestCommandBody.justification !== undefined) {
 formData.append('justification', updateDocumentRequestCommandBody.justification)
 }
formData.append('implantationDate', updateDocumentRequestCommandBody.implantationDate)
formData.append('reason', updateDocumentRequestCommandBody.reason)
formData.append('reasonFields', JSON.stringify(updateDocumentRequestCommandBody.reasonFields));
formData.append('observation', updateDocumentRequestCommandBody.observation)

      return instance<void | CreateDocumentRequestCommandResponse>(
      {url: `/api/v1/document-request/${id}`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getUpdateDocumentRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequest>>, TError,{id: number;data: BodyType<UpdateDocumentRequestCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequest>>, TError,{id: number;data: BodyType<UpdateDocumentRequestCommandBody>}, TContext> => {
    
const mutationKey = ['updateDocumentRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentRequest>>, {id: number;data: BodyType<UpdateDocumentRequestCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDocumentRequest(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentRequest>>>
    export type UpdateDocumentRequestMutationBody = BodyType<UpdateDocumentRequestCommandBody>
    export type UpdateDocumentRequestMutationError = ErrorType<unknown>

    export const useUpdateDocumentRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequest>>, TError,{id: number;data: BodyType<UpdateDocumentRequestCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentRequest>>,
        TError,
        {id: number;data: BodyType<UpdateDocumentRequestCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getDocumentRequestFile = (
    id: number,
    params?: GetDocumentRequestFileParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<Blob>(
      {url: `/api/v1/document-request/${id}/file`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetDocumentRequestFileQueryKey = (id: number,
    params?: GetDocumentRequestFileParams,) => {
    return [`/api/v1/document-request/${id}/file`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentRequestFileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequestFile>>, GetDocumentRequestFileParams['page']>, TError = ErrorType<unknown>>(id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']> = ({ signal, pageParam }) => getDocumentRequestFile(id,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequestFile>>>
export type GetDocumentRequestFileInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentRequestFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequestFile>>, GetDocumentRequestFileParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetDocumentRequestFileParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequestFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequestFile>>, GetDocumentRequestFileParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequestFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequestFile>>, GetDocumentRequestFileParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentRequestFile>>, GetDocumentRequestFileParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentRequestFile>>, QueryKey, GetDocumentRequestFileParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestFileInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestFileQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequestFile>>> = ({ signal }) => getDocumentRequestFile(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestFileQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequestFile>>>
export type GetDocumentRequestFileQueryError = ErrorType<unknown>


export function useGetDocumentRequestFile<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetDocumentRequestFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequestFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequestFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFile<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequestFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequestFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFile<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestFile<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentRequestFileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequestFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequestFile>>> = ({ signal }) => getDocumentRequestFile(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequestFileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequestFile>>>
export type GetDocumentRequestFileSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentRequestFileSuspense<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetDocumentRequestFileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFileSuspense<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequestFileSuspense<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequestFileSuspense<TData = Awaited<ReturnType<typeof getDocumentRequestFile>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetDocumentRequestFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentRequestFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequestFileSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



